<div style="position: absolute;top: 160px;left: 50%; z-index: 45; transform: translateX(-50%);  "
    class="wrap uk-margin-bottom">

    <div class="uk-width-1-1" style="margin-left: -20px;" uk-grid>
        <div class="uk-margin uk-display-inline-block research-form-controls" style="width: 420px;">
            <div class="uk-form-controls uk-display-inline-block uk-position-relative uk-width-1-1">
                <span *ngIf="vehicleLoading === false" class="uk-form-icon uk-form-icon-flip">
                    <img src="../../../assets/icons/Search.svg" width="24px" height="24px" alt="user" />
                </span>
                <span *ngIf="vehicleLoading === true" class="uk-form-icon uk-form-icon-flip">
                    <div style="width:24px; height: 24px;" uk-spinner></div>
                </span>
                <!-- <input class="search-bar" type="text" [(ngModel)]="vehicleSearch"
                    (ngModelChange)="searchManager($event)" (focus)="toggleSuggestions(true)"
                    placeholder="Localiser un véhicule" (focusout)="toggleSuggestions(false)"
                    style="padding-right: inherit !important;"> -->

                <div [class.display-none]="vehicleDisplay === false" class="searchDashboard">
                    <!-- <div [class.display-none]="vehicleDisplay === false" class="arrow" style="background-color: red;"> -->
                    <!-- </div> -->

                    <div
                        [class.display-none]="vehicleNoResult === false || stationNoResult === false || userNoResult === false || reservationNoResult === false">
                        Aucun résultat
                    </div>

                    <div class="categorie" [class.display-none]="vehicleNoResult === true">
                        <h3>Véhicules</h3>
                        <ul [class.display-none]="vehicleNoResult === true">
                            <li *ngFor="let option of vehicleOptions" (click)="setVehicleSearch(option)">
                                <span class="color-orange">{{ option.name }}</span> - {{ option.brand }} {{ option.model
                                }}
                            </li>
                        </ul>
                    </div>

                    <div class="categorie" [class.display-none]="stationNoResult === true">
                        <h3>Stations</h3>
                        <ul [class.display-none]="stationNoResult === true">
                            <li *ngFor="let option of stationsOptions">
                                {{ option.name }}
                            </li>
                        </ul>
                    </div>

                    <div class="categorie" [class.display-none]="userNoResult === true">
                        <h3>Utilisateur</h3>
                        <!-- <div [class.display-none]="usersOptions.length === 0" class="arrow"></div> -->
                        <ul [class.display-none]="userNoResult === true">
                            <li class="result" *ngFor="let option of usersOptions">
                                <span class="color-orange">{{ option.LastName }} {{ option.FirstName }}</span> - {{
                                option.CodeSociety }}
                            </li>
                        </ul>
                    </div>

                    <div class="categorie" [class.display-none]="reservationNoResult === true">
                        <h3>Réservation</h3>
                        <!-- <div [class.display-none]="reservationsOptions.length === 0" class="arrow"></div> -->
                        <ul [class.display-none]="reservationNoResult === true">
                            <li *ngFor="let option of reservationsOptions">
                                <span class="color-orange">{{ option.Code }}</span> - {{ option.User }} - {{
                                option.Vehicle }}
                            </li>
                        </ul>
                    </div>
                </div>

                <!-- <div [class.display-none]="vehicleDisplay === false" class="suggestions">
                    <div [class.display-none]="stationsOptions.length === 0" class="arrow"></div>
                    <div [class.display-none]="stationNoResult === false">
                        Pas de stations
                    </div>
                    <div [class.display-none]="vehicleNoResult === true" *ngFor="let option of stationsOptions">
                        {{ option.name }}
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</div>

<div *ngIf="loading === true">
    <div uk-spinner class="uk-position-center"></div>
</div>

<div>
    <div style="width:100%; height: calc(100vh - 155px); position: relative; z-index: 30;" id="map"></div>
</div>

<div style="background-color: red; position:absolute; bottom: 10px;">

</div>